/**
 * This directive forces an input to be ALL CAPS
 */
export class CapsLockDirective implements angular.IDirective {
    public static $name: string = 'capsLock';
    public restrict: string = 'A';
    public require: string = 'ngModel';

    public link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
        /* Force the model value to be uppercase */
        ngModel.$parsers.push((val: string) => {
            return val ? val.toUpperCase() : '';
        });

        /* Display the view value as uppercase (without wasting processing on actually making it uppercase) */
        element.addClass('ALLCAPS');
    }

    public static Factory() {
        let directive = () => {
            return new CapsLockDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
